import { createModel } from '@rematch/core';
import { adminService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';
import { AdminState } from 'src/modules/admin/models/admin';

const defaultState: AdminState = {
    isHrAdmin: false,
    isLookerDashboardIframeVisible: false,
};

export const admin = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        setIsHrAdmin: (state, isHrAdmin: boolean): AdminState => {
            return {
                ...state,
                isHrAdmin,
            };
        },
    },
    effects: dispatch => ({
        async fetchAdminInfo(): Promise<void> {
            const response = await adminService.fetchAdminInfo();

            dispatch.admin.setIsHrAdmin(response?.isHrAdmin || false);
        },
    }),
});
